import React, { useEffect, useMemo } from "react";

// others
import { Row, Space } from "antd";
import Button from "../../../molecules/Button";
import { Up, Add, Edit, Down, Change } from "../../../../assets/svg";
import { useSelector } from "react-redux";
import { disablePaymentSchedule } from "./utils";
import { useParams } from "react-router-dom";

interface IProps {
  iKey: string;
  disable?: boolean;
  isActive: boolean;
  renewal?: boolean;
  handleEditPress: (key: string) => void;
  showAdditionalTermsBtn?: boolean;
  disableAdditionalTermsBtn?: boolean;
  showViewBreakdownBtn?: boolean;
}

const index = (props: IProps) => {
  // redux states
  let { bookingDetails } = useSelector((state: any) => state.newBooking);
  const changePlan = disablePaymentSchedule(bookingDetails, true);
  const disableStyle = {
    opacity: !props.disable ? 1 : 0.5,
    cursor: !props.disable ? "inherit" : "not-allowed",
  };
  const typeOfRenewal = useParams();
  let newRenewalType = typeOfRenewal["*"];

  const disableStyleAdditionalTermsBtn = {
    opacity: 1,
    cursor: "inherit",
  };
  const disableRenewalTerms = useMemo(() => {
    const status = bookingDetails?.renewalStatus;
    const isRenewalToRenewal = newRenewalType === "renewalToRenewal";

    if ((status === "sent_for_approval" || status === "renewal_accepted") && props?.iKey === "4") {
      return true;
    }else if(status === "active" && !isRenewalToRenewal){
        return true;
    }else{
      return false;
    }
  }, [bookingDetails?.renewalStatus, newRenewalType]);

  const disableRenewal = {
    opacity: 0.5,
    cursor: "not-allowed",
  };

  const disableChangePlanStyle = {
    opacity: !changePlan ? 1 : 0.5,
    cursor: !changePlan ? "inherit" : "not-allowed",
  };

  return (
    <Row style={{ marginTop: "12px" }}>
      <Space size="large">
        {props.iKey === "3" && (
          <>
            <Button
              label="Add Payment"
              style={disableStyle}
              disabled={props.disable}
              className="change-button"
              onClick={(event) => {
                event.stopPropagation();
                props.handleEditPress("5");
              }}
              icon={<Add width="18px" height="18px" style={{ marginRight: "8px" }} />}
            />

            {!props.renewal && (
              <Button
                style={disableChangePlanStyle}
                disabled={changePlan}
                className="change-button"
                label="Change Payment Plan"
                onClick={(event) => {
                  event.stopPropagation();
                  props.handleEditPress("8");
                }}
                icon={<Change width="18px" height="18px" style={{ marginRight: "8px" }} />}
              />
            )}
          </>
        )}

        {/* for TOR Rules */}
        {props?.iKey === "32" && (
          <>
            <Button
              label="TOR Rules"
              style={disableStyle}
              disabled={props.disable}
              className="change-button"
              onClick={(event) => {
                event.stopPropagation();
                props.handleEditPress("32");
              }}
            />

            <Button
              label="Add Turnover Report"
              style={disableStyle}
              disabled={props.disable}
              className="change-button"
              onClick={(event) => {
                event.stopPropagation();
                props.handleEditPress("30");
              }}
              icon={<Add width="18px" height="18px" style={{ marginRight: "8px" }} />}
            />
          </>
        )}
        {props.showAdditionalTermsBtn && (
          <Button
            label="Additional Terms"
            style={disableStyleAdditionalTermsBtn}
            disabled={false}
            className="change-button"
            onClick={(event) => {
              event.stopPropagation();
              props.handleEditPress("50");
            }}
          />
        )}
        {props.showViewBreakdownBtn && (
          <Button
            label="View Breakdown"
            className="change-button"
            onClick={(event) => {
              event.stopPropagation();
              props.handleEditPress("move-out-breakdown");
            }}
          />
        )}
        {props.handleEditPress && props?.iKey !== "32" && (
          <div
            style={disableRenewalTerms || props.disable ? disableRenewal : null}
            className="edit-icon"
            onClick={(event) => {
              event.stopPropagation();
              !props.disable && !disableRenewalTerms && props.handleEditPress(props.iKey);
            }}
          >
            <Edit />
          </div>
        )}

        {!props.isActive ? <Up /> : <Down />}
      </Space>
    </Row>
  );
};

export default index;
